<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Documente utile"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box">
                <div class="title-div">
                    <h3>Documente utile</h3>
                </div>
                <div class="documents-box">
                    <a href="https://mfe.gov.ro/poc-ghidul-consolidat-aferent-actiunii-4-1-1-investitii-in-activitati-productive/" target="_blank" class="document-box">
                        <p>Ghidul solicitantului <br>(varianta consolidată)</p>
                        <font-awesome-icon icon="file-word"></font-awesome-icon>
                    </a>
                    <a href="https://ec.europa.eu/environment/gpp/eu_gpp_criteria_en.htm" target="_blank" class="document-box">
                        <p style="margin-bottom: 0 !important;">Green Public Procurement (GPP)</p>
                        <p style="font-size: 12px; font-weight: 400">În mod orientativ, pentru stabilirea
                            criteriilor verzi, se vor avea în vedere
                            informațiile publicate aici. <br>
                            (conform Ghidului Solicitantului pag 21)</p>
                    </a>
                    <a href="/documents/sme_definition_user_guide_ro.pdf" target="_blank" download class="document-box">
                        <p style="margin-bottom: 0 !important;">Instrucțiuni IMM</p>
                        <p style="font-size: 12px; font-weight: 400">(Manualul utilizatorului pentru definiția
                            IMM-urilor / Comisia Europeană)</p>
                        <font-awesome-icon icon="file-pdf"></font-awesome-icon>
                    </a>
                    <a href="/documents/AM_POC_clarificări_mediu.pdf" download class="document-box">
                        <p>AM POC Clarificări</p>
                        <font-awesome-icon icon="file-pdf"></font-awesome-icon>
                    </a>
                    <!--<a href="/documents/Instructiuni_IMM_400ro.pdf" download class="document-box">
                        <p>Instructiuni IMM</p>
                        <font-awesome-icon icon="file-pdf"></font-awesome-icon>
                    </a>
                    <a href="https://eur-lex.europa.eu/legal-content/RO/TXT/HTML/?uri=CELEX:32021R2139&from=EN#d1e32-348-1" target="_blank" class="document-box">
                        <p>Regulamentul delegat (UE) 2021/2139 al CE</p>
                        <font-awesome-icon icon="file-pdf"></font-awesome-icon>
                    </a>
                    <a href="/documents/Criteriile UE achizitiile publice ecologice.rar" download class="document-box">
                        <p style="margin-bottom: 0 !important;">Green Public Procurement (GPP)</p>
                        <p style="font-size: 12px; font-weight: 400">Criteriile UE privind achizițiile
                            publice ecologice pentru mobilier</p>
                    </a>
                    <a href="/documents/Criteriile UE privind achizitiile publice pentru echipamente.rar" download class="document-box">
                        <p style="margin-bottom: 0 !important;">Green Public Procurement (GPP)</p>
                        <p style="font-size: 12px; font-weight: 400">Criteriile UE privind achizițiile publice ecologice pentru echipamente de procesare a imaginii</p>
                    </a>
                    <a href="/documents/Criteriile UE privind achizitiile publice pentru computere.rar" download class="document-box">
                        <p style="margin-bottom: 0 !important;">Green Public Procurement (GPP)</p>
                        <p style="font-size: 12px; font-weight: 400">Criteriile UE privind achizițiile publice ecologice pentru computere, monitoare, tablete smartphones</p>
                    </a>
                    <a href="/documents/Instrument oficial UE trimitere la conditiile tehnice.xlsx" download class="document-box">
                        <p style="margin-bottom: 0 !important;">Instrument Oficial al UE care face trimitere la condițiile tehnice Anexe (web)</p>
                    </a>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { BIconInfoCircle } from "bootstrap-vue";
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faFileArchive, faFileWord, faFilePdf } from "@fortawesome/free-solid-svg-icons";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
    library.add(faFileArchive, faFileWord, faFilePdf);
    export default {
        components: {
            BIconInfoCircle,
            SketchBreadcrumb,
            FontAwesomeIcon
        },
        mounted() {
            this.$store.dispatch('pageLoading/setLoading', false)
        }
    }
</script>

<style scoped>
.title-div{
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
.title-div h3{
    font-size: 25px;
    color:#aa93a8;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.flex{
    display: flex;
}
.flex-column{
    flex-direction: column;
}
p{
    font-size: 14px;
}
.documents-box{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 18px;
}
.document-box{
    background: #f8f8f8;
    border-radius: 6px;
    padding: 25px;
    display: flex;
    width: 317px;
    min-height: 200px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: 0.4s;
    cursor: pointer;
    text-decoration: none;
}
.document-box:hover{
    background: #e1e0e0;
}
.document-box p{
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #545a6f;
    margin-bottom: 25px;
}
.document-box svg{
    font-size: 35px;
    color: #545a6f;
}
@media (max-width: 1600px) {
    .document-box{
        max-width: 32%;
    }
}
@media (max-width: 1500px) {
    .document-box{
        max-width: 31%;
    }
}
</style>

